/**
 * Throws when the signal is aborted, like AbortSignal.prototype.throwIfAborted, which older browsers lack (Chrome 100,
 * Firefox 97 and Safari 15.4 brought it; trace-portal's browsers include iOS Safari 12, where calling it threw a
 * TypeError before any sign-in). It throws the signal's reason, or an AbortError where the browser has no reason.
 */
export function throwIfAborted(signal) {
    if (!signal?.aborted)
        return;
    throw signal.reason ?? new DOMException('The operation was aborted.', 'AbortError');
}
//# sourceMappingURL=abort.js.map